import { initializeApp } from "firebase/app";
import "firebase/auth";
import { getAuth, signInWithEmailAndPassword, sendPasswordResetEmail } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyAQ9gJUQ-uhdf-l6KmBEid0D2TWIbvCR-U",
    authDomain: "caiolab-d323a.firebaseapp.com",
    projectId: "caiolab-d323a",
    storageBucket: "caiolab-d323a.appspot.com",
    messagingSenderId: "402210082609",
    appId: "1:402210082609:web:0372ab59d338ce67d02a10",
    measurementId: "G-WT5H7DE1EK"
};


const app = initializeApp(firebaseConfig);
const auth = getAuth(app)

export { auth, app, signInWithEmailAndPassword, sendPasswordResetEmail }
